import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-question-answer-dropdown',
  templateUrl: './question-answer-dropdown.component.html',
  styleUrls: ['./question-answer-dropdown.component.scss']
})
export class QuestionAnswerDropdownComponent {
  @Input() question: string;
  @Input() answer: string;

  isDropdownOpen = false;

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
}